import EventEmitter from 'eventemitter3';
import { Scene } from "../../tools/Scene";
import { Button } from "../../ui/Button";
import { LocalizationManager } from '../../managers/LocalizationManager';

export class QuitScene extends Scene{

    container:Phaser.GameObjects.Image|null = null;
    containerLabel:Phaser.GameObjects.Text|null = null;

    xButton:Button|null = null;
    checkButton:Button|null = null;

    emitter:EventEmitter = new EventEmitter();
    blackScreen:Phaser.GameObjects.Image|null = null;
    group:Phaser.GameObjects.Group|null = null;
    open:boolean = false;
    
    constructor(sceneConfig){
        super(sceneConfig);
    }
    
    prescaleCreate(){
        let position;
        let style;
        let button:Button;
        let text;
        let image;
        let group = this.add.group({});
        this.group = group;

        position = this.scaleManager.getRelativePosition(.5,.5);
        image = this.add.image(position.x,position.y,'gen_overlay');
        image.setAlpha(0.5);
        image.setTint(0x000000);
        image.setInteractive();
        this.blackScreen = image;

        position = this.scaleManager.getRelativePosition(0.5,0.5,true);
        image = this.add.image(position.x,position.y,'gfx_pop2');
        group.add(image);
        this.container = image;

        text = this.add.text(position.x -560,position.y - 170,LocalizationManager.getText('ARE_YOU_SURE'),LocalizationManager.getStyle('ARE_YOU_SURE'));
        text.setOrigin(0,1);
        group.add(text);
        this.containerLabel = text;

        button = new Button(this,'close_button',position.x-320,position.y);
        button.buttonHighlightSprite = 'close_button';
        button.buttonPressedSprite = 'close_button_pressed';
        button.emitter.on('buttonup',this.startClose,this);
        group.addMultiple(button.group.getChildren());
        this.xButton = button;

        button = new Button(this,'check_button',position.x+320,position.y);
        button.buttonHighlightSprite = 'check_button';
        button.buttonPressedSprite = 'check_button_pressed';
        button.emitter.on('buttonup',this.quit,this);
        group.addMultiple(button.group.getChildren());
        this.checkButton = button;

        Phaser.Actions.IncY(this.group!.getChildren(),-2000);

        //Add Scene event bindings
        this.events.on('resize',this.onSceneResize,this);
    }
    
    reorient(landscape:boolean){
        let position;
        if(landscape){
            if(this.container){
                position = this.scaleManager.getRelativePosition(0.5,0.5,true);
                this.container!.setPosition(position.x,position.y);
                this.containerLabel!.setPosition(position.x-310,position.y-95);
                Phaser.Actions.SetXY(this.xButton!.group.getChildren(),position.x-160,position.y);
                Phaser.Actions.SetXY(this.checkButton!.group.getChildren(),position.x+160,position.y);
                if(this.open==false){
                    Phaser.Actions.IncY(this.group!.getChildren(),-2000);
                }
            }
            if(this.blackScreen){
                position = this.scaleManager.getRelativePosition(.5,.5);
                this.blackScreen.setPosition(position.x,position.y);
                // this.blackScreen.setTexture('lan_gen_bg');
                this.blackScreen.setInteractive();
            }
        }else{
            if(this.container){
                position = this.scaleManager.getRelativePosition(0.5,0.5,true);
                this.container!.setPosition(position.x,position.y);
                this.containerLabel!.setPosition(position.x-310,position.y-95);
                Phaser.Actions.SetXY(this.xButton!.group.getChildren(),position.x-160,position.y);
                Phaser.Actions.SetXY(this.checkButton!.group.getChildren(),position.x+160,position.y);
                if(this.open==false){
                    Phaser.Actions.IncY(this.group!.getChildren(),-2000);
                }
            }
            if(this.blackScreen){
                position = this.scaleManager.getRelativePosition(0.5,0.5,true);
                position = this.scaleManager.getRelativePosition(.5,.5);
                this.blackScreen.setPosition(position.x,position.y);
                // this.blackScreen.setTexture('por_gen_bg');
                this.blackScreen.setInteractive();
            }
        }
        this.rescaleBackground();
    }

    rescaleBackground():void {
        //rescale background
        let ratio = this.scaleManager.getRatio();

        if(this.blackScreen!.width * this.blackScreen!.scaleX != window.innerWidth || this.blackScreen!.height * this.blackScreen!.scaleY != window.innerHeight)
        {
            this.blackScreen!.setScale(this.sys.canvas.width/this.blackScreen!.width / ratio! , this.sys.canvas.height/this.blackScreen!.height / ratio!);
        }
    }


    startOpen(){
        this.scene.bringToTop(undefined!);
        this.blackScreen!.setVisible(true);
        this.open = true;
        this.tweens.add({
            targets : this.group!.getChildren(),
            y: '+= 2000',
            duration: .5 * 1000,
            ease: 'Power3'
        });
    }

    startClose(){
        this.emitter.emit('close');
        
        this.open = false;
        this.tweens.add({
            targets : this.group!.getChildren(),
            y: '+=-2000',
            duration: 1 * 250,
            ease: 'Power3',
            onComplete:this.onCloseComplete,
            onCompleteParams: [this]
        });
        
    }

    onSceneResize(event:Phaser.Scene):void {
        this.rescaleBackground();
    }
    
    onCloseComplete(tween,targets,scene){
        if(scene.open==false){
            scene.scene.sendToBack(undefined!);
            if(this.blackScreen) this.blackScreen!.setVisible(false);
        }   
    }

    quit(){
        this.scene.sendToBack(undefined!);
        this.emitter.emit('quit');
    }
}